import React, { useEffect, useState } from "react";
import "./agent-ui.css";
import HouseCard from "../ui/HouseCard";
import { AxiosAuthGet } from "../../api/api";
import Loading from "../ui/Loading";
import { useNavigate } from "react-router-dom";


const PropertyListings = () => {
  const url = "agent/properties/";
  const [propData, setPropData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const getProp = () => {
    setIsLoading(true);
    AxiosAuthGet(url)
      .then((res) => {
        // console.log(res);
        setPropData(res.data);
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err.response);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getProp();
    // eslint-disable-next-line
  }, []);

  const clickProp = (item) => {
    localStorage.setItem("property", JSON.stringify(item));
    navigate(`/agent/property/house-view/${item.id}`);
  };

  return (
    <div className="prop-list">
      <h3>Property Listings</h3>
      {isLoading && <Loading />}
      {!isLoading && (
        <div className="estates_houses house_cont" style={{ margin: 0, padding: "20px 0" , }}>
          {propData?.map((item, i) => {
            return (
              <HouseCard
                key={i}
                img={item?.images[0]?.link}
                tag={item?.propertyType}
                title={item?.name}
                add={item?.propertyAddress}
                area={Number(item?.area)?.toLocaleString()}
                bed={item?.bedrooms}
                bath={item?.bathrooms}
                price={`#${item?.propertyPrice?.toLocaleString()}`}
                btnClick={() => clickProp(item)}
                houseStyle={{ width: "100%" }}
                propType={"Land"}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PropertyListings;
